module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-4.56bf019b.jpg";